import _ from 'lodash'

function getRoundedScore(value, featureToggles) {
  const scoreType = _.get(featureToggles, ['scoreType'])
  let roundedValue = value

  if (scoreType === 'int') {
    roundedValue *= 100
    return _.round(roundedValue)
  }

  return _.round(roundedValue, 2)
}

export default getRoundedScore
